import React, { useState } from 'react';
import FAQSImage from "../../assets/image_10.png"

import { FaPlus, FaMinus } from "react-icons/fa6";


const faqs = [
    {
        question: "How do I place an order?",
        answer:
            "Simply use the Tuber app or website to enter your order details and select a store. Our system assigns the nearest available driver.",
    },
    {
        question: "How fast will my order be delivered?",
        answer: "Our average delivery time is 2 hours or less.",
    },
    {
        question: "Can I track my order?",
        answer: "Yes! You’ll receive real-time tracking updates from pickup to drop-off.",
    },
    {
        question: "What if something goes wrong with my order?",
        answer: "Contact our support team, and we’ll resolve it immediately.",
    },
];

export default function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleFAQ = (index) => {
        setActiveIndex((prev) => (prev === index ? null : index));
    };

    return (
        <section className="py-10 md:py-20 px-4 bg-gray-50">
            <div className="max-w-7xl mx-auto">
                <div>
                    <span className='text-primary block font-bold mb-3 text-sm md:text-lg'>FAQ</span>

                    <h1 className='text-2xl md:text-4xl font-bold md:mb-4 text-headings'>
                        Frequently Asked Questions
                    </h1>
                </div>


                <div className='grid md:grid-cols-2 gap-10 pt-10'>
                    {/* Left Image */}
                    <div className="flex justify-center h-[350px] md:h-[500px]">
                        <img
                            src={FAQSImage}
                            alt="image 8"
                            className="w-full h-full rounded-xl object-cover"
                        />
                    </div>

                    {/* FAQ Right Panel */}
                    <div className="space-y-2 py-5">
                        {faqs.map((faq, index) => (
                            <div key={index} className={`bg-white border border-gray-100 rounded-lg overflow-hidden transition-all duration-300 ${activeIndex === index ? "bg-gray-100" : "bg-white"}`}>
                                <button
                                    onClick={() => toggleFAQ(index)}
                                    className={`w-full text-left flex p-4 justify-between items-center gap-2 ${activeIndex === index ? "bg-primary text-white" : "bg-white text-headings"}`}
                                >
                                    <h2 className="font-medium text-base md:text-lg">{faq.question}</h2>

                                    <span className={`transition-all duration-300 w-5 h-5 rounded-full flex justify-center items-center ${activeIndex === index ? "text-white" : "text-light_black"}`}>
                                        {activeIndex === index ? <FaMinus /> : <FaPlus />}
                                    </span>
                                </button>

                                <div
                                    className={`text-light_black text-base transition-all duration-300 ease-in-out ${activeIndex === index ? "max-h-96 px-4 pb-4 pt-4 opacity-100" : "max-h-0 opacity-0"
                                        } overflow-hidden`}
                                >
                                    {faq.answer}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
